import React, { PureComponent, PropTypes } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import moment from 'moment';

import {
  Button,
  ShiftCard,
} from '../../../../../shared';

import ClockCanvas from '../ClockCanvas';

import styles from './styles.scss';

export default class ClockConfirm extends PureComponent {
  constructor(props) {
    super(props);
    this.handleKeypress = this.handleKeypress.bind(this);
  }

  componentWillMount() {
    document.addEventListener('keydown', this.handleKeypress);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeypress);
  }

  getShiftDetail(schedule) {
    return this.props.shiftDetails.find(d =>
      d.id === schedule.detailsId &&
      d.departmentId === schedule.departmentId) || {};
  }

  getTeam(schedule) {
    return this.props.teams.find(t =>
      t.id === schedule.departmentId) || {
      colour: '#59636f',
      name: 'No Team',
    };
  }

  getShiftCard() {
    if (!this.props.features.shiftcard.value) {
      return null;
    }

    const type = this.props.type === 'in'
      ? 'current' : 'next';

    const schedule = this.props.currentUser.schedules[type];

    if (!schedule || !schedule.start) {
      return (
        <h3 className={styles.ShiftCardNoShift}>
          Have a great day!
        </h3>
      );
    }

    return (
      <div>
        <h2 className={styles.ShiftCardHeading}>
          {type === 'current' ? 'Today\'s Shift' : 'Next Shift'}
        </h2>
        <ShiftCard
          schedule={schedule}
          shiftDetail={this.getShiftDetail(schedule)}
          team={this.getTeam(schedule)}
        />
      </div>
    );
  }

  handleKeypress(e) {
    this.props.setAndStartTimer();
    if (e.key === 'Enter') {
      e.preventDefault();
      this.props.clearUser();
    }
  }

  render() {
    return (
      <div className={styles.ClockConfirm} onClick={this.props.clearUser}>
        <ClockCanvas
          setCanvas={this.props.setCanvas}
          shouldCapture={this.props.features.camera.value}
        />

        <h1 className={this.props.type}>
          Clocked {this.props.type} at {moment().format('h:mm a')}
        </h1>

        <ReactCSSTransitionGroup
          component='div'
          className={styles.shiftcardAnimation}
          transitionName='slide'
          transitionAppear
          transitionEnter={false}
          transitionLeave={false}
          transitionAppearTimeout={600}
        >
          {this.getShiftCard()}
        </ReactCSSTransitionGroup>

        <div className={styles.undo}>
          <p>Pressed the wrong button?</p>
          <Button onClick={this.props.onUndoClockin}>
            <p>Undo</p>
          </Button>
        </div>
      </div>
    );
  }
}

ClockConfirm.propTypes = {
  clearUser: PropTypes.func.isRequired,
  currentUser: PropTypes.shape({
    schedules: PropTypes.object.isRequired,
  }).isRequired,
  features: PropTypes.shape({
    camera: PropTypes.object.isRequired,
    shiftcard: PropTypes.object.isRequired,
  }).isRequired,
  setCanvas: PropTypes.func.isRequired,
  shiftDetails: PropTypes.array.isRequired,
  teams: PropTypes.array.isRequired,
  type: PropTypes.string.isRequired,
  onUndoClockin: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/timeclock/userhub/home/ClockIn/ClockConfirm/index.jsx